import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../atoms/modal';

const ModalContainer = function ModalContainer(props) {
    const {
        showmodal, showheader, showfooter, modaltitle, modalclosebuttontext, children,
        confirmbuttontext, confirmaction, toggleshow, modalcardstyle,
    } = props;

    const [show, setshow] = useState(showmodal);

    return (
        <div>
            <Modal
                title={modaltitle}
                closebuttontext={modalclosebuttontext}
                show={toggleshow ? showmodal : show}
                showheader={showheader}
                showfooter={showfooter}
                setshow={toggleshow || setshow}
                confirmbuttontext={confirmbuttontext}
                confirmaction={confirmaction}
                modalcardstyle={modalcardstyle}
            >
                {children}
            </Modal>
        </div>
    );
};

ModalContainer.propTypes = {
    children: PropTypes.node.isRequired,
    modaltitle: PropTypes.string.isRequired,
    modalclosebuttontext: PropTypes.string.isRequired,
    showmodal: PropTypes.bool,
    showheader: PropTypes.bool,
    showfooter: PropTypes.bool,
    confirmbuttontext: PropTypes.string,
    confirmaction: PropTypes.func,
    toggleshow: PropTypes.func,
    modalcardstyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

ModalContainer.defaultProps = {
    showmodal: false,
    showheader: false,
    showfooter: false,
    confirmbuttontext: '',
    confirmaction: () => {},
    toggleshow: null,
    modalcardstyle: {},
};

export default ModalContainer;
